import React from "react";
import { TextField } from "@mui/material";
import { useEnglishOnly } from "../../util/englishOnly";

/**
 * 비밀번호 입력칸 — 계정명({@link AccountIdField})과 <b>같은 규칙</b>으로 한글 입력을 막는다.
 *
 * type="password" 는 대개 OS 가 IME 를 꺼 주지만, 우리 화면은 모두 '표시' 토글로 type 을 text 로 바꾼다.
 * 그 순간 IME 가 살아나 한글이 그대로 들어가고, 비밀번호는 가려져 있어 사용자는
 * <b>틀린 이유를 볼 수 없다</b> — 그냥 "비번은 맞는데 로그인이 안 된다" 로만 보인다.
 * 그래서 막는 데서 끝내지 않고 한글을 쳤다는 사실을 helperText 로 알려 준다.
 *
 * 걸러 내는 건 한글 등 <b>비ASCII</b> 뿐이다. 숫자·특수문자는 서버 규칙이 요구하므로 그대로 통과시킨다.
 *
 * @param {string}   value      현재 값
 * @param {function} onChange   정제된 값을 <b>문자열</b>로 넘겨준다
 * @param {string}   [helperText] 평소 helperText — 한글 안내가 뜨는 동안에는 그쪽이 우선한다
 */
export default function PasswordField({ value, onChange, inputProps, helperText, error, ...rest }) {
    const { notice, sanitize, clearNotice, imeProps } = useEnglishOnly();

    const handleChange = (e) => {
        const el = e.target;
        const clean = sanitize(el.value);
        // 부모 state 가 그대로면 리렌더가 없어 DOM 에 한글이 남는다 — input 값도 직접 되돌린다.
        if (el.value !== clean) el.value = clean;
        onChange?.(clean);
    };

    return (
        <TextField
            {...rest}
            value={value}
            onChange={handleChange}
            error={error || !!notice}
            helperText={notice || helperText}
            inputProps={{
                ...imeProps,
                ...inputProps,
                // 조합이 안 끝난 채 빠져나가는 경우까지 정리한다.
                onBlur: (e) => {
                    const clean = sanitize(e.target.value);
                    if (clean !== e.target.value) onChange?.(clean);
                    inputProps?.onBlur?.(e);
                },
                onFocus: (e) => {
                    clearNotice();
                    inputProps?.onFocus?.(e);
                },
                onCompositionStart: imeProps.onCompositionStart,
            }}
        />
    );
}
